import {Controller} from "@/controllers/Controller";

/**
 * Controller for prompt API (ms-marketing) : prompt de rédaction à coller dans l'outil d'écriture (ChatGPT...)
 */
export class PromptController extends Controller {

    // Catalogue des modèles de rédaction
    static getTemplates() {
        return this.requestBuilder("GET", `/marketing/prompt/templates`, true);
    }

    // Prompt d'une publication, avec le modèle choisi (par défaut celui de la publication, du groupe ou conseillé)
    static build(publicationId, templateId) {
        return this.requestBuilder("GET", `/marketing/prompt/${publicationId}${this.buildParams({templateId})}`, true);
    }
}
